interface RadioProps {
    name: string,
    radioStatus: boolean,
    onChange: () => void,
}

/**
 * 
 * @param props イベント参加登録　ラジオボタンのコンポーネント
 * @returns 
 */
export function JoinRadioButton(props: RadioProps){
    let checked = false;
    if((props.name === '参加' && props.radioStatus === true) || (props.name === '不参加' && props.radioStatus === false)){
        checked = true;
    }

    return(
        <label className="frm-lb">
            <input 
                type="radio"
                name="part-btn"
                className="frm-rdo"
                checked={checked}
                onChange={props.onChange}
            />
            <span className="frm-rdo-tx"><i className="frm-rdo-faker"></i>{props.name}</span>
        </label>
    )
}